import React from 'react'
import './alert.css'
class ReturnGetAlert extends React.Component{
	constructor(props){
		super(props)
	}
	render(){
		return(
		<div className="return-role-notice">

				<span className="return-role-title">永恒之塔回归礼包领取规则：</span>
				
				<span>1、同时满足以下3个领取条件，即可领取专属回归礼包：</span>
				<ul>
					    <li>1）心享俱乐部黄金及黄金以上会员；</li>
					
						<li>2）超过90天未登录任何盛趣游戏；</li> 

						<li>3）当年回归登录永恒之塔。 </li>

				</ul>
				
				<span className="return-role-title">永恒之塔消耗礼包领取规则：</span>
			

				<span>1、同时满足以下3个领取条件，即可领取专属回归消耗礼包：</span>

				<ul>
					    <li>1）心享俱乐部黄金及黄金以上会员；</li>
					
						<li>2） 当年回归登录永恒之塔；</li> 

						<li>3） 回归后消耗达到指定消耗金额，累计消耗达到1000元、5000元时，可领取对应消耗档次的消耗礼包。</li>
						<li>4） 同一认证手机只可领取一次，永恒之塔消耗礼包一年（自然年）只可领取一次。</li>
				</ul>
				<span>2、账号累计消耗计算规则：</span>
				<ul>
					    <li>1）当年账号回归日起开始计算回归后消耗，回归后累计消耗按单个账号计算；</li>
					
						<li className="re-set-weight">2）累计消耗每年（自然年）年底12月31日清空，不累计至次年；</li> 
						<li>3）消耗指永恒之塔游戏内及官方页面上消费的点券；点券兑换游戏专用币的兑换行为不算消耗。</li>
						

				</ul>
			
			</div> 

			)

	}
}
export default ReturnGetAlert




// WEBPACK FOOTER //
// ./src/component/return-get-alert/alert78.js